import React, { ReactNode, useMemo, useState } from 'react';
import { StudiestedApiProvider } from './StudiestedApiContext';
import { LoginApiProvider } from './LoginApiContext';
import { StudentApiProvider } from './StudentApiContext';
import { PraksisstedApiProvider } from './PraksisstedApiContext';

export interface SessionStore {
  showTimeoutWarning: boolean;
  resetShowTimeoutWarning: () => void;
  setKeepAlive: () => void;
}

export const SessionContext = React.createContext<SessionStore>({
  showTimeoutWarning: false,
  resetShowTimeoutWarning: () => {},
  setKeepAlive: () => {},
});

const FIFTY_FIVE_MINUTES_IN_MILLISECONDS = 3300000;

let timer: number;

export const SessionProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const [showTimeoutWarning, setShowTimeoutWarning] = useState<boolean>(false);

  const sessionStore: SessionStore = useMemo(() => {
    const setKeepAlive = () => {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        setShowTimeoutWarning(true);
      }, FIFTY_FIVE_MINUTES_IN_MILLISECONDS);
    };

    const resetShowTimeoutWarning = () => {
      setShowTimeoutWarning(false);
    };

    return {
      setKeepAlive,
      resetShowTimeoutWarning,
      showTimeoutWarning,
    };
  }, [showTimeoutWarning]);

  return (
    <SessionContext.Provider value={sessionStore}>
      <LoginApiProvider>
        <StudiestedApiProvider>
          <PraksisstedApiProvider>
            <StudentApiProvider>{children}</StudentApiProvider>
          </PraksisstedApiProvider>
        </StudiestedApiProvider>
      </LoginApiProvider>
    </SessionContext.Provider>
  );
};
